import { render, staticRenderFns } from "./ReactiveChangePassword.vue?vue&type=template&id=af24abca"
import script from "@/scripts/auth/reactiveChangePassword.js?vue&type=script&lang=js&external"
export * from "@/scripts/auth/reactiveChangePassword.js?vue&type=script&lang=js&external"
import style0 from "./ReactiveChangePassword.vue?vue&type=style&index=0&id=af24abca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports